import {
  BookOpenText,
  Menu,
  Moon,
  Search,
  Sun,
  X,
} from "lucide-react";
import { GitHubMark } from "./GitHubMark";

type SiteHeaderProps = {
  theme: "dark" | "light";
  onToggleTheme: () => void;
  onOpenSearch: () => void;
  mobileNavOpen: boolean;
  onToggleMobileNav: () => void;
};

const navItems = [
  ["知识地图", "#knowledge-map"],
  ["深度阅读", "#reader"],
  ["每周更新", "#weekly-updates"],
  ["来源", "#sources"],
];

export function SiteHeader({
  theme,
  onToggleTheme,
  onOpenSearch,
  mobileNavOpen,
  onToggleMobileNav,
}: SiteHeaderProps) {
  return (
    <header className="site-header">
      <a className="brand" href="#top" aria-label="返回页首">
        <BookOpenText aria-hidden="true" />
        <span>Agent Harness 工程</span>
      </a>

      <nav className="desktop-nav" aria-label="主导航">
        {navItems.map(([label, href]) => (
          <a key={href} href={href}>
            {label}
          </a>
        ))}
      </nav>

      <div className="header-actions">
        <button
          className="icon-button search-button"
          type="button"
          onClick={onOpenSearch}
          aria-label="搜索文档"
        >
          <Search aria-hidden="true" />
          <span>搜索文档</span>
          <kbd>⌘K</kbd>
        </button>
        <button
          className="icon-button"
          type="button"
          onClick={onToggleTheme}
          aria-label={theme === "dark" ? "切换到浅色主题" : "切换到深色主题"}
        >
          {theme === "dark" ? <Sun aria-hidden="true" /> : <Moon aria-hidden="true" />}
        </button>
        <a
          className="icon-button"
          href="https://github.com/yizhiyanhua-ai/agent-harness-engineering-zh"
          target="_blank"
          rel="noreferrer"
          aria-label="打开 GitHub 仓库"
        >
          <GitHubMark />
        </a>
        <button
          className="icon-button mobile-menu-button"
          type="button"
          onClick={onToggleMobileNav}
          aria-expanded={mobileNavOpen}
          aria-label={mobileNavOpen ? "关闭导航" : "打开导航"}
        >
          {mobileNavOpen ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
        </button>
      </div>

      {mobileNavOpen && (
        <nav className="mobile-nav" aria-label="移动端导航">
          {navItems.map(([label, href]) => (
            <a key={href} href={href} onClick={onToggleMobileNav}>
              {label}
            </a>
          ))}
          <a
            href="https://github.com/yizhiyanhua-ai/agent-harness-engineering-zh"
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>
        </nav>
      )}
    </header>
  );
}
